import React, { FC } from 'react'
import EditVendorContainer from 'containers/Vendors/EditVendor'

const EditVendorPage: FC = () => <EditVendorContainer />

export default EditVendorPage
